"use client";

import { useApiGet } from "@/hooks/use-api";
import { integrationKeys } from "./keys";
import type { GitHubConnectionStatus } from "./types";

/**
 * useGithubStatus
 *
 * Returns the GitHub connection status for the current user.
 * Fetched only when the settings Connections tab opens (not pre-fetched globally).
 *
 * Usage:
 *   const { connected, githubLogin, isLoading } = useGithubStatus();
 */
export function useGithubStatus() {
  const { data, isLoading, isError, refetch } = useApiGet<GitHubConnectionStatus>(
    integrationKeys.github(),
    "/api/github/connection",
    undefined,
    {
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );

  return {
    connected: data?.connected ?? false,
    githubLogin: data?.githubLogin,
    githubAvatarUrl: data?.githubAvatarUrl,
    installations: data?.installations,
    isLoading,
    isError,
    refetch,
  };
}
